import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface NotesBadgeProps {
  count: number;
  onClick: () => void;
}

export function NotesBadge({ count, onClick }: NotesBadgeProps) {
  const { t } = useTranslation("notes");
  if (count === 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex"
      aria-label={t("badge.count", { count })}
    >
      <Badge variant="secondary" className={cn("h-5 px-2 text-xs font-medium")}>
        {count}
      </Badge>
    </button>
  );
}
